const TIMES_ORDER_STATUS = [
  {
    key: "on_time",
    min: 0,
    max: 9,
    label: "on_time",
    style: "bg-green-300 border border-green-900 shadow-green-400",
  },
  {
    key: "on_the_limit",
    min: 10,
    max: 19,
    label: "on_the_limit",
    style: "bg-amber-300 border border-amber-900 shadow-amber-400",
  },
  {
    key: "urgent",
    min: 20,
    max: Infinity,
    label: "urgent",
    style: "bg-rose-300 border border-rose-900 shadow-rose-400",
  },
];

export { TIMES_ORDER_STATUS };
